import { motion } from "framer-motion";
import { Icon } from "@/components/common/Icon";
import { SPACES } from "@/data/spaces";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const SpacesGrid = ({ onPick }) => (
  <div data-testid="hero-spaces-grid">
    <p className="mono text-[11px] uppercase tracking-[0.2em] text-slate-300">Tap your space for a tailored quote</p>
    <div className="mt-4 flex flex-wrap gap-2">
      {SPACES.map((s, i) => (
        <motion.button
          key={s.name}
          type="button"
          onClick={() => onPick(s.name)}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 + i * 0.025, duration: 0.35 }}
          title={s.hook}
          data-testid={`space-tile-${slug(s.name)}`}
          className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.06] px-3.5 py-2 text-[13px] font-medium text-white backdrop-blur-md transition-colors hover:border-[#E8927F]/70 hover:bg-white/[0.14]"
        >
          <Icon name={s.icon} className="h-4 w-4 text-[#E8927F]" /> {s.name}
        </motion.button>
      ))}
    </div>
  </div>
);
